export default __webpack_public_path__ + "static/carbon-fibre-dd8e622c6afaa107f207dcfa8d58336a.png";